<template>
    <div>
        <router-link to="/" class="underline">
            &laquo; Back to Main Menu
        </router-link>

        <br><br>

        <ul class="node" type="headline" level="1">
            <li>
                <div class="node-value">
                    <span class="prefix"><span>*</span></span>
                    <span class="value"> Connect via S3</span>
                </div>
            </li>
        </ul>

        <br>

        <div class="node-content highlight">Your information is only saved in this browser.</div>

        <br>

        <form @submit.prevent="app.setConfig(config)" class="sftp">
            <div class="field">
                <label>Endpoint:</label>
                <input type="text" v-model="config.endpoint" placeholder="https://s3.us-east-1.amazonaws.com">
            </div>

            <div class="field">
                <label>Region:</label>
                <input type="text" v-model="config.region" placeholder="us-east-1">
            </div>

            <div class="field">
                <label>Access Key ID:</label>
                <input type="text" v-model="config.accessKeyId" placeholder="XYXYXYXYXYXYXYXYXYXY">
            </div>

            <div class="field">
                <label>Secret Access Key:</label>
                <input type="password" v-model="config.secretAccessKey" placeholder="******************">
            </div>

            <div class="field">
                <label>Bucket:</label>
                <input type="text" v-model="config.bucket" placeholder="my-bucket">
            </div>

            <div class="field">
                <label>Path:</label>
                <input type="text" v-model="config.path" placeholder="/">
            </div>

            <div class="field node" type="headline">
                <button class="no-button">
                    <mark class="done">
                        Connect &raquo;
                    </mark>
                </button>

                <a @click.prevent="reset()" href="javascript:;">
                    Reset
                </a>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['app'],

    components: {
        // Node
    },

    data() {
        var _ = this,
            config = JSON.parse(JSON.stringify(_.app.config));

        config.type = 's3';

        return {
            config: config
        };
    },

    methods: {
        reset() {
            var _ = this;

            if (confirm('Are you sure you want to reset your settings? You will lose access to your Org Mode file.')) {
                _.config = {};

                _.app.config = {};
                _.app.file = '';
                _.app.connection = undefined;

                _.$router.push('/');
            }
        }
    }
};
</script>
